export const getTimeConditions = ($formatters: any, travelItem: any, type: 'start' | 'end' = 'start') => {
  const { timeConditions } = travelItem
  if (!Array.isArray(timeConditions)) {
    return []
  }

  const values = [] as { [key: string]: any }[]

  timeConditions
    .filter((item: any) => type.toUpperCase() === item.type)
    .forEach((item: { [key: string]: any }) => {
      let textType = ''
      let textTimeType = ''
      const { name } = item
      const time = $formatters.datetime(item.time, 'DD/MM/YYYY HH:mm')

      if (item.type === 'START') {
        textType = 'Bắt đầu'
      }

      if (item.type === 'END') {
        textType = 'Kết thúc'
      }

      if (item.timeType === 'EARLIEST') {
        textTimeType = 'sớm nhất'
      }

      if (item.timeType === 'LATEST') {
        textTimeType = 'muộn nhất'
      }

      if (textType && textTimeType && time) {
        const label = `${textType} ${name} ${textTimeType} ${time}`
        values.push({
          label,
          timeType: item.timeType
        })
      }
    })

  return values
}
